import GlobalApolloWrapper from "./middlewares/GlobalApolloWrapper";


const exports = {
    wrappers: [GlobalApolloWrapper]
}
export default exports;